import { useState } from "react";
import { OfferType } from "@KassaroAB/shared/types/enums/OfferType";
import type { RestCreateOffer, RestOffer } from "@KassaroAB/shared/types/offer";
import { PercentageForm } from "./PercentageForm";
import { BuyXPayYForm } from "./BuyXPayYForm";
import { QuantityPriceForm } from "./QuantityPriceForm";
import { FixedPriceForm } from "./FixedPriceForm";
import { ComboForm } from "./ComboForm";

interface OfferFormProps {
  formId: string;
  offer?: RestOffer;
  savedTick?: number;
  onSubmit: (data: RestCreateOffer) => void;
  onDirtyChange?: (isDirty: boolean) => void;
}

export const OfferForm = ({
  formId,
  offer,
  savedTick,
  onSubmit,
  onDirtyChange,
}: OfferFormProps) => {
  const [createType, setCreateType] = useState<OfferType>(
    OfferType.PERCENTAGE,
  );
  const type = offer?.type ?? createType;

  const shared = {
    formId,
    offer,
    savedTick,
    onSubmit,
    onDirtyChange,
    onTypeChange: offer ? undefined : setCreateType,
  };

  if (type === OfferType.PERCENTAGE) {
    return <PercentageForm key={type} {...shared} />;
  }
  if (type === OfferType.BUY_X_PAY_Y) {
    return <BuyXPayYForm key={type} {...shared} />;
  }
  if (type === OfferType.QUANTITY_PRICE) {
    return <QuantityPriceForm key={type} {...shared} />;
  }
  if (type === OfferType.FIXED_PRICE) {
    return <FixedPriceForm key={type} {...shared} />;
  }
  if (type === OfferType.COMBO) {
    return <ComboForm key={type} {...shared} />;
  }
  return null;
};
